import { Transition } from '@unseenco/taxi';
import Tween from 'gsap';
import { gHome, gAbout, gFAQ, gBlog } from './gradients.js'
import { moveNav } from './moveNav.js';

export default class Slide extends Transition {


    /**
     * Handle the transition leaving the previous page.
     * @param { { from: HTMLElement, trigger: string|HTMLElement|false, done: function } } props
     */
    onLeave({ from, trigger, done }) {
        Tween.fromTo( from, 0.5, { opacity: 1}, { opacity: 0, onComplete: done});
    }
  
    /**
     * Handle the transition entering the next page.
     * @param { { to: HTMLElement, trigger: string|HTMLElement|false, done: function } } props
     */
    onEnter({ to, done }) {

        let toGradient = gHome;

        if (to.id == 'home') {
            toGradient = gHome;
            Tween.to( $('.blob'), { duration: 1.25, ease: "elastic.out(1, 0.5)", top: moveNav('home') + ($('.blob').height() / 2)});
        }
        else if (to.id == 'about') {
            toGradient = gAbout;
            Tween.to( $('.blob'), { duration: 1.25, ease: "elastic.out(1, 0.5)", top: moveNav('about') + ($('.blob').height() / 2)});
        }
        else if (to.id == 'faq') {
            toGradient = gFAQ;
            Tween.to( $('.blob'), { duration: 1.25, ease: "elastic.out(1, 0.5)", top: moveNav('faqs') + ($('.blob').height() / 2)});
        }
        else if (to.id == 'blog') {
            toGradient = gBlog;
            Tween.to( $('.blob'), { duration: 1.25, ease: "elastic.out(1, 0.5)", top: moveNav('blog') + ($('.blob').height() / 2)});

        }

        Tween.to( to.parentElement, { backgroundImage: toGradient});
        Tween.fromTo( to, 0.5, { opacity: 0}, { opacity: 1, onComplete: done});
    }
  }